import { Scroll } from '@/lib/scroll'
import { onPageIn, onMount, onDestroy } from '@/modules/_'

export default function (element: HTMLElement, dataset: DOMStringMap) {
  const navLinks: NodeListOf<Element> = document.querySelectorAll(
    '[data-service="link"]'
  )
  const sections: NodeListOf<Element> = document.querySelectorAll(
    '[data-service="section"]'
  )

  // Smooth scroll functionality
  navLinks.forEach((link: Element) => {
    link.addEventListener('click', function (e: Event): void {
      e.preventDefault()
      const targetId: string | null = (link as HTMLAnchorElement).getAttribute(
        'href'
      )
      if (!targetId) return

      const targetSection: HTMLElement | null = document.getElementById(
        targetId.substring(1)
      )

      if (targetSection) {
        targetSection.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        })
      }
    })
  })

  // Intersection Observer for scroll spy
  const observerOptions: IntersectionObserverInit = {
    root: null,
    rootMargin: '-20% 0px -70% 0px',
    threshold: 0,
  }

  const observer: IntersectionObserver = new IntersectionObserver(
    (entries: IntersectionObserverEntry[]) => {
      entries.forEach((entry: IntersectionObserverEntry) => {
        if (entry.isIntersecting) {
          const sectionId: string | null = entry.target.getAttribute('id')
          console.log(sectionId)

          // Remove active class from all nav links
          navLinks.forEach((link: Element) =>
            link.classList.remove('is--active')
          )

          // Add active class to corresponding nav link
          const activeLink: Element | null = document.querySelector(
            `[href="#${sectionId}"]`
          )
          if (activeLink) {
            activeLink.classList.add('is--active')
          }
        }
      })
    },
    observerOptions
  )

  function createDottedLines(): void {
    const CIRCLE_SIZE: number = 5
    const MIN_OPACITY: number = 0.1
    const MAX_OPACITY: number = 1.0

    const dottedLineContainers: NodeListOf<Element> =
      document.querySelectorAll('.dotted_line_wrap')

    dottedLineContainers.forEach((container: Element) => {
      container.innerHTML = ''

      // Set up flexbox container
      const containerElement = container as HTMLElement
      containerElement.style.display = 'flex'
      containerElement.style.flexDirection = 'column'
      containerElement.style.alignItems = 'center'
      containerElement.style.justifyContent = 'space-between'

      const containerHeight: number = containerElement.offsetHeight
      const textColor: string = window.getComputedStyle(containerElement).color

      // Calculate number of circles based on container height
      const circlesCount: number = Math.max(Math.floor(containerHeight / 12), 5) // Minimum 5 circles

      // Create circles
      for (let i: number = 0; i < circlesCount; i++) {
        const circle: HTMLDivElement = document.createElement('div')

        // Calculate opacity fade
        const centerIndex: number = (circlesCount - 1) / 2
        const distanceFromCenter: number = Math.abs(i - centerIndex)
        const maxDistance: number = Math.floor(circlesCount / 2)
        const opacityRatio: number = 1 - distanceFromCenter / maxDistance
        const opacity: number =
          MIN_OPACITY + opacityRatio * (MAX_OPACITY - MIN_OPACITY)

        // Style circle
        circle.style.width = `${CIRCLE_SIZE}px`
        circle.style.height = `${CIRCLE_SIZE}px`
        circle.style.borderRadius = '50%'
        circle.style.backgroundColor = textColor
        circle.style.opacity = opacity.toString()
        circle.style.flexShrink = '0' // Prevent shrinking

        containerElement.appendChild(circle)
      }
    })
  }

  onMount(() => {
    createDottedLines()

    // Observe all sections
    sections.forEach((section: Element) => {
      observer.observe(section)
    })

    // Optional: Re-run on window resize to recalculate
    window.addEventListener('resize', function (): void {
      setTimeout(createDottedLines, 100)
    })
  })

  onPageIn(async () => {})

  onDestroy(() => {})
}
